import React, {useState} from "react";
import {
  useNavigate,
  Link
} from 'react-router-dom';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';



import OpenJobFormPCCreative from './OpenJobFormPCCreative';
import OpenJobFormMobileCreative from './OpenJobFormMobileCreative';
import OpenJobFormTabletCreative from './OpenJobFormTabletCreative';



const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function OpenJobFormCreative(props) {

   const quitStartFillingFormCreative = () => {
     props.quitStartFillingFormCreative();
   }

    return (

        <div style={{width: viewportWidth+'px'}}>

              {!isMobileOnly && !isTablet &&
                <BrowserView>
                  <OpenJobFormPCCreative quitStartFillingFormCreative={quitStartFillingFormCreative}/>
               </BrowserView>
             }

              {isMobileOnly &&
        			  <MobileView>
        	         <OpenJobFormMobileCreative quitStartFillingFormCreative={quitStartFillingFormCreative}/>
        			 </MobileView>
        			}

        			{isTablet &&
        			  <TabletView>
        			     <OpenJobFormTabletCreative quitStartFillingFormCreative={quitStartFillingFormCreative}/>
        			  </TabletView>
        			}

        </div>

    );




}
